import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";
import Dropzone from "react-dropzone";
import hash from "hash-sum";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";

import {
	GridCell,
	Button,
	cloneAllProps,
	Main,
	createGalleryImage,
	delay,
	ContainedImage,
	getTagArray,
	getTagString,
	logProps,
} from "src/components/common";
import Topbar from "src/components/Editor/Topbar";
import { Box, FormGroup, Label, TextInput, } from "./GalleryImage";

// --------------------------------------------------

const Wrapper = styled(Main)`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`;

const BoxWrapper = styled.div`
	width: 600px;
	max-width: 80vw;
`;

const DropzoneWrapper = styled.div`
	width: 100%;
	position: relative;
	padding-top: 100%;
	margin-bottom: 1em;
`;

const dropzoneStyle = {
	width: "100%",
	height: "100%",
	position: "absolute",
	top: 0,
};

const DropzoneInnerWrapper = styled.div`
	width: 100%;
	height: 100%;
	border: 2px #ddd dashed;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

const DropzoneInnerText = styled.div`
	font-size: 4em;
	opacity: 0.5;
`;

const UploadingWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

const UploadingText = styled.div`
	margin-top: 1em;
	font-size: 2em;
	text-align: center;
`;

const UploadingImageWrapper = styled.div`
	width: 20em;
	background-color: rgba(0,0,0,0.1);
`;

const DropzoneInner = ({ isDragActive, isDragReject, }) => (
	<DropzoneInnerWrapper>
		<DropzoneInnerText>
			{
				isDragActive
				? "Drop your files!"
				: "Upload"
			}
		</DropzoneInnerText>
	</DropzoneInnerWrapper>
);

const enhance = compose(
	connect(R.pick([ "space", ])),
	withState("uploading", "setUploading", false),
	// withState("currentFile", "setCurrentFile", false),
	withState("tags", "setTags", []),
	withHandlers({
		setTags: ({ setTags, }) => e => {
			setTags(getTagArray(e.target.value));
		},
	}),
	withPropsOnChange([ "tags", ], R.pipe(
		R.prop("tags"),
		getTagString,
		R.objOf("tagString"),
	)),
	withHandlers({
		onDrop: ({ space, history, setUploading, setCurrentFile, tags, }) => files => {
			setUploading(true);
			const uploadHash = hash(Date.now().toString() + (1000 * Math.random()));
			
			// files.reduce((p, file) => (
			// 	p.then(() => {
			// 		setCurrentFile(file);
			// 		return createGalleryImage({
			// 			file,
			// 			space,
			// 			log: true,
			// 			uploadHash,
			// 		})
			// 		// .then(delay(100))
			// 	})
			// ), Promise.resolve())

			Promise.all(files.map(file => {
				// setCurrentFile(file);
				return createGalleryImage({
					file,
					space,
					log: true,
					uploadHash,
					tags,
				});
			}))
			.then(() => {
				setUploading(false, () => {
					history.push("/editor/gallery/uploaded/" + uploadHash);
				});
			});
		},
	}),
);

const Comp = ({ onDrop, uploading, currentFile, tagString, setTags, }) => (
	<div>
		<Topbar title = "Upload"/>
		<Wrapper>
			{
				uploading
				? (
					<UploadingWrapper>						
						<UploadingText>Uploading. Please wait...</UploadingText>
					</UploadingWrapper>
				)
				: (

					<BoxWrapper>
						<Box>
							<GridCell>
								<DropzoneWrapper>
									<Dropzone
										accept = "image/*"
										onDrop = { onDrop }
										style = { dropzoneStyle }
										children = { DropzoneInner }
										multiple = { true }
									/>
								</DropzoneWrapper>
								<FormGroup>
									<Label>Tags</Label>
									<TextInput name = "tags" value = { tagString } onChange = { setTags }/>
								</FormGroup>
							</GridCell>
						</Box>
					</BoxWrapper>
				)
			}
			
		</Wrapper>
		
	</div>
);

export default enhance(Comp);


// WEBPACK FOOTER //
// ./src/components/Editor/Images/Upload.js